import { BaseError } from './base';

export class ValueMustBeDefinedError extends BaseError {
  constructor(message: string) {
    super({
      cause: null,
      code: 'value_must_be_defined_error',
      docsUrl: null,
      name: 'ValueMustBeDefined',
      shortMessage: message,
    });
  }
}
